import { render } from "./ModalPopUp.vue?vue&type=template&id=c48220d0&scoped=true"
import script from "./ModalPopUp.vue?vue&type=script&lang=js"
export * from "./ModalPopUp.vue?vue&type=script&lang=js"

import "./ModalPopUp.vue?vue&type=style&index=0&id=c48220d0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c48220d0"]])

export default __exports__